"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createWallet = createWallet;
exports.importWallet = importWallet;
exports.exportWallet = exportWallet;
var web3_js_1 = require("@solana/web3.js");
/**
 * Creates a new Solana wallet (keypair)
 * @returns A new Keypair instance
 */
function createWallet() {
    return web3_js_1.Keypair.generate();
}
/**
 * Imports a wallet from a secret key
 * @param secretKey The secret key as a Uint8Array
 * @returns A Keypair instance
 */
function importWallet(secretKey) {
    return web3_js_1.Keypair.fromSecretKey(secretKey);
}
/**
 * Exports a wallet to its secret key
 * @param wallet The wallet to export
 * @returns The secret key as a Uint8Array
 */
function exportWallet(wallet) {
    return wallet.secretKey;
}
